import React from "react";

const DAY_SHORT = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

export default function BookingCard({
  safeEvent,
  selectedDate,
  selectedEndDate,
  calendarMonthLabel,
  onPrevMonth,
  onNextMonth,
  calendarCells,
  toYmd,
  ymdToTime,
  isRangeCategory,
  isDateAllowed,
  monthLoading,
  monthAvailableDates,
  isPickingRangeEnd,
  setSelectedDate,
  setSelectedEndDate,
  setIsPickingRangeEnd,
  setCheckError,
  setAvailabilityMeta,
  setIsDateAvailable,
  setSelectedTimeSlot,
  isTable,
  timeSlots,
  slotAvailability,
  selectedTimeSlot,
  monthCapacityByDate,
  eachDateYmd,
  toShortDateLabel,
  toRangeLabel,
}) {
  return (
    <>
      <div className="booking-topbar">
        <div className="booking-topbar-left" title={String(safeEvent?.address || "")}>
          <span className="booking-topbar-icon" aria-hidden>
            ⊙
          </span>
          <span className="booking-topbar-text">{safeEvent?.address || "Address not available"}</span>
        </div>
        <div className="booking-topbar-right">
          <span className="booking-topbar-icon" aria-hidden>
            ⌁
          </span>
          <span className="booking-topbar-text">{toRangeLabel(selectedDate, selectedEndDate)}</span>
        </div>
      </div>

      <div className="booking-top-row">
        <span className="booking-label">Select Date</span>
        <span className="booking-month-nav">
          <button type="button" onClick={onPrevMonth}>
            {"<"}
          </button>
          <strong>{calendarMonthLabel}</strong>
          <button type="button" onClick={onNextMonth}>
            {">"}
          </button>
        </span>
      </div>

      <div className="booking-calendar">
        {DAY_SHORT.map((d) => (
          <div key={d} className="booking-weekday">
            {d}
          </div>
        ))}
        {calendarCells.map((cell, idx) => {
          if (!cell) return <div key={`empty-${idx}`} className="booking-day empty" />;
          const ymd = toYmd(cell);
          const startTs = ymdToTime(selectedDate);
          const endTs = ymdToTime(selectedEndDate || selectedDate);
          const currentTs = ymdToTime(ymd);
          const rangeMin = Math.min(startTs || currentTs, endTs || currentTs);
          const rangeMax = Math.max(startTs || currentTs, endTs || currentTs);
          const inRange =
            isRangeCategory &&
            Boolean(selectedDate) &&
            Boolean(selectedEndDate) &&
            currentTs >= rangeMin &&
            currentTs <= rangeMax;
          const active = selectedDate === ymd || (isRangeCategory && Boolean(selectedEndDate) && selectedEndDate === ymd);
          const allowed = isDateAllowed(cell);
          const availableInApi =
            !monthLoading && Object.keys(monthAvailableDates).length > 0 ? Boolean(monthAvailableDates[ymd]) : true;
          return (
            <button
              key={ymd}
              type="button"
              disabled={!allowed || !availableInApi}
              className={`booking-day ${active ? "active" : ""} ${inRange ? "in-range" : ""}`}
              onClick={() => {
                if (isRangeCategory) {
                  if (!selectedDate || !isPickingRangeEnd) {
                    setSelectedDate(ymd);
                    setSelectedEndDate("");
                    setIsPickingRangeEnd(true);
                  } else if (ymd >= selectedDate) {
                    setSelectedEndDate(ymd);
                    setIsPickingRangeEnd(false);
                  } else {
                    setSelectedDate(ymd);
                    setSelectedEndDate("");
                    setIsPickingRangeEnd(true);
                  }
                } else {
                  setSelectedDate(ymd);
                  setSelectedEndDate(ymd);
                  setIsPickingRangeEnd(false);
                }
                setCheckError("");
                setAvailabilityMeta("Checking availability...");
                setIsDateAvailable(true);
                setSelectedTimeSlot("");
              }}
            >
              {cell.getDate()}
            </button>
          );
        })}
      </div>

      {isTable ? (
        <div className="booking-time-wrap">
          <p className="booking-section-title">Select available time slot</p>
          <div className="booking-slots">
            {timeSlots.map((slot) => (
              <button
                key={slot.value}
                type="button"
                className={`booking-slot-btn ${selectedTimeSlot === slot.value ? "active" : ""} ${
                  slotAvailability[slot.value] === false ? "unavailable" : ""
                }`}
                disabled={slotAvailability[slot.value] === false}
                onClick={() => setSelectedTimeSlot(slot.value)}
              >
                {slotAvailability[slot.value] === false ? `${slot.label} (Unavailable)` : slot.label}
              </button>
            ))}
          </div>
        </div>
      ) : (
        <div className="booking-time-wrap">
          <p className="booking-section-title">Date Availability</p>
          <div className="booking-availability-grid">
            {eachDateYmd(selectedDate, selectedEndDate || selectedDate).map((ymd) => {
              const cap = Number(monthCapacityByDate?.[ymd] ?? 0);
              const soldOut = !monthLoading && cap <= 0;
              return (
                <div key={`avl-${ymd}`} className={`booking-avl-card active ${soldOut ? "soldout" : ""}`}>
                  <span className="booking-avl-date">{toShortDateLabel(ymd)}</span>
                  <span className="booking-avl-cap">
                    {soldOut ? "Sold Out" : monthLoading ? "Checking..." : `Avl: ${cap}`}
                  </span>
                </div>
              );
            })}
          </div>
        </div>
      )}
    </>
  );
}
